import React, {Component} from 'react';
import {AgencyHeader} from "../agency/AgencyHeader"
import {UserInfo} from "./UserInfo";
import {UserEmailAlertsCenter} from "./UserEmailAlertsCenter";
import {LocalStorage} from "../../utils/LocalStorage";

export class UserSettings extends Component {
    render() {
        // `/user-configuration` no trae el id en la ruta: sin el de quien está logueado, «Mis alertas» pedía
        // `user/undefined/module/marketing/alerts`.
        const userId = this.props.userId || LocalStorage.fetchUserId();
        return (
            <section className="section-content">
                <AgencyHeader/>
                <div className="section-body h-items">
                    <UserInfo/>
                    <UserEmailAlertsCenter userId={userId}/>
                </div>

            </section>
        )
    }
}
